<template>
  <div class="d-flex" style="min-height: 600px;">
    <iframe
      style="max-height: 500px; max-width: 90%"
      class="border-0 w-100 top-0 h-100 position-absolute img-margin"
      src="https://player.vimeo.com/video/544483447?color=44619b&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;speed=1"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: "side-video"
};
</script>

<style scoped>
.img-margin {
  margin: 0 auto !important;
}
</style>
